import type { CSSObject } from '@emotion/react'
import { Color, Typography, Shadow } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lapidary'
import type { SidebarProps, StyleProps } from './types'

export const container = ({
  elevation,
  theme,
}: StyleProps & Required<Pick<SidebarProps, 'elevation'>>): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,
  color: Color[theme].Text.Default,
  ...Shadow[elevation],
  ...Typography.T500,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',

  ...modernWithFallback(
    [
      {
        overflowBlock: 'auto',
        overflowInline: 'hidden',
      },
      {
        overflowX: 'hidden',
        overflowY: 'auto',
      },
    ],
    'overflowBlock: auto'
  ),
  blockSize: '100%',
  inlineSize: '25vi',
})
